module.exports = __webpack_public_path__ + "static/img/banner-品诺电影@2x.3752aef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner-品诺电影@2x.png
// module id = jsmX
// module chunks = 1